<template>
	<div @paste="abrirPegar" :class="{ 'wa-messages-mode': whatsappStyle }">
		<v-card-text>
			<v-row>
				<!-- Columna de mensajes -->
				<v-col cols="12">
					<span v-for="(mensaje, i) in filterMensajes" :key="mensajeKey(mensaje, i)">
		    <div class="message text-only mb-8">
		      <div :class="`${ mensaje.mio == 0 ? 'noresponse' : 'response' }`">
		        <p 
		          class="text" 
		          v-if="mensaje.type == 1"
		          style="white-space: pre-line"
		          @contextmenu="show(mensaje, $event)"
		        >
		          {{ mensaje.mensaje }}
		          <!-- <v-btn
				        class="forward-btn"
				        icon="mdi-share"
				        size="small"
				        variant="text"
				        @click="forwardMessage(mensaje)"
				      >
				      </v-btn> -->
		        </p>

		        <!-- Tipo de texto es Imagennnnn -->
		        <p 
		          class="text" 
		          v-if="mensaje.type == 2"
		          style="white-space: pre-line"
		          @click="verImagen( srcMediaMensaje(mensaje) )"
		          type="button"
		          @contextmenu="show(mensaje, $event)"
		        >
		          <img
		            v-if="srcMediaMensaje(mensaje)"
		            :src="srcMediaMensaje(mensaje)"
		            alt="Imagen"
		            width="300"
		            loading="lazy"
		            @error="onImgMediaError(mensaje)"
		          />
		        </p>

		        <!-- Para cuando se envían stickers -->
		        <p 
		          class="text" 
		          v-if="mensaje.type == 'sticker'"
		          style="white-space: pre-line"
		          @contextmenu="show(mensaje, $event)"
		        >
		          <img v-if="mensaje.mio == 0" :src="srcMediaMensaje(mensaje)" alt="Sticker" width="150" loading="lazy"/>
		          <img v-if="mensaje.mio == 1" :src="srcMediaMensaje(mensaje)" alt="Sticker" width="150" loading="lazy"/>
		        </p>

		        <!-- Tipo documento: PDF preview; Word solo tarjeta (no visor PDF). -->
		        <p 
		          class="text" 
		          v-if="mensaje.type == 4"
		          style="white-space: pre-line"
		          @contextmenu="show(mensaje, $event)"
		        >
		          <template v-if="esDocumentoWord(mensaje)">
		            <a
		              class="twilio-doc-card d-inline-flex align-center"
		              :href="srcMediaMensaje(mensaje) || '#'"
		              target="_blank"
		              rel="noopener"
		              @click.prevent="descargarMediaMensaje(mensaje)"
		            >
		              <v-icon color="#1565c0" size="28" class="mr-2">mdi-file-word-box</v-icon>
		              <span>
		                <span class="d-block twilio-pdf-card__name">{{ nombreArchivoMedia(mensaje) }}</span>
		                <span class="text-caption grey--text" v-if="etiquetaMetaMedia(mensaje)">{{ etiquetaMetaMedia(mensaje) }}</span>
		              </span>
		            </a>
		            <div v-if="modoAdjuntosRh" class="mt-1" @click.stop>
		              <v-btn
		                v-if="puedeAnalizarCvRh(mensaje)"
		                small
		                tile
		                color="secondary"
		                @click.stop="emitirAnalizarCv(mensaje)"
		              >
		                <v-icon left small>mdi-file-search-outline</v-icon>
		                Ver resumen
		              </v-btn>
		              <span v-else-if="esDocAntiguoRh(mensaje)" class="text-caption grey--text">
		                DOC antiguo no se puede analizar
		              </span>
		            </div>
		          </template>
		          <template v-else-if="mensaje.media_estado === 'fallido' || (!mensaje.MediaUrl0 && !mensaje.media_url && !mensaje.imagenFake)">
		            <v-alert dense text type="warning" class="mb-0 pa-2">
		              {{ mensaje.mensaje || 'Adjunto no disponible' }}
		            </v-alert>
		          </template>
		          <button v-else type="button" class="twilio-pdf-preview" @click="verPDF(mensaje)">
		            <iframe
		              v-if="srcPdfPreview(mensaje) && !mensaje._mediaFallido"
		              class="twilio-pdf-preview__frame"
		              :key="srcPdfPreview(mensaje)"
		              :src="srcPdfPreview(mensaje)"
		              loading="lazy"
		              title="Preview PDF"
		              @load="onPdfFrameLoad($event, mensaje)"
		            />
		            <span class="twilio-pdf-preview__bar">
		              <v-icon color="#d32f2f" size="20">mdi-file-pdf-box</v-icon>
		              <span class="twilio-pdf-card__name">{{ nombreArchivoMedia(mensaje) }}</span>
		            </span>
		          </button>
		          <div v-if="modoAdjuntosRh && !esDocumentoWord(mensaje)" class="mt-1" @click.stop>
		            <v-btn
		              v-if="puedeAnalizarCvRh(mensaje)"
		              small
		              tile
		              color="secondary"
		              @click.stop="emitirAnalizarCv(mensaje)"
		            >
		              <v-icon left small>mdi-file-search-outline</v-icon>
		              Ver resumen
		            </v-btn>
		          </div>
		        </p>

		        <!-- Tipo Audio: transcripción + player -->
		        <p 
		          class="text pa-0 pt-2 px-2 audio" 
		          v-if="mensaje.type == 3"
		          style="white-space: pre-line; width: 300px;"
		          @contextmenu="show(mensaje, $event)"
		        >
		          <span
		            v-if="textoTranscripcionAudio(mensaje)"
		            class="d-block mb-2 black--text"
		            style="white-space: pre-line; font-size: 14px;"
		          >{{ textoTranscripcionAudio(mensaje) }}</span>
		          <v-alert
		            v-if="!mensaje.MediaUrl0"
		            dense
		            text
		            type="warning"
		            class="mb-2 pa-2"
		          >
		            Audio sin archivo guardado (MediaUrl0 vacío). Solo se ve la transcripción si llegó.
		          </v-alert>
		          <template v-else>
		            <v-btn
		              v-if="!esMediaVisible(mensaje, i)"
		              small
		              outlined
		              color="primary"
		              @click="mostrarMedia(mensaje, i)"
		            >
		              <v-icon left small>mdi-play-circle-outline</v-icon>
		              Escuchar audio
		            </v-btn>
		            <div v-else>
		              <audio
		                controls
		                style="width: 100%;"
		                preload="metadata"
		                :key="'au-' + (mensaje.idmensajes || i) + '-' + mensaje.MediaUrl0"
		                @error="onAudioError(mensaje, $event)"
		              >
		                <source :src="srcMediaMensaje(mensaje)" :type="mimeAudioDesdeNombre(mensaje.MediaUrl0)">
		              </audio>
		              <a
		                class="text-caption d-block mt-1"
		                :href="srcMediaMensaje(mensaje)"
		                target="_blank"
		                rel="noopener"
		              >Abrir archivo</a>
		              <span v-if="mensaje._audioError" class="text-caption red--text d-block">
		                No se pudo cargar el audio (¿archivo en servidor?).
		              </span>
		            </div>
		          </template>
		        </p>

		        <!-- Tipo video: carga bajo demanda -->
		        <p 
		          class="text" 
		          v-if="mensaje.type == 5"
		          style="white-space: pre-line"
		          @contextmenu="show(mensaje, $event)"
		        >
		          <v-btn
		            v-if="!esMediaVisible(mensaje, i)"
		            small
		            outlined
		            color="primary"
		            @click="mostrarMedia(mensaje, i)"
		          >
		            <v-icon left small>mdi-video-outline</v-icon>
		            Ver video
		          </v-btn>
		          <video v-else controls width="300" preload="none">
		            <source :src="srcMediaMensaje(mensaje)">
		          </video>
		        </p>

		        <!-- Mensaje -->
		        <p 
		          class="text mt-2" 
		          v-if="mensaje.type == 2 && mensaje.mensaje"
		          style="white-space: pre-line"
		        >
		          {{ mensaje.mensaje }}
		        </p>

		        <!-- Mensaje -->
		        <p 
		          class="text mt-2" 
		          v-if="mensaje.type == 4 && mensaje.mensaje"
		          style="white-space: pre-line"
		        >
		          {{ mensaje.mensaje }}
		        </p>

		        <!-- Nombre del usuario (salientes). Sin iderp / sin join → Sistema -->
		        <p 
		          v-if="mensaje.mio == 1"
		          :class="`${ mensaje.mio == 0 ? 'time' : 'response-time time'} black--text`"
		        >{{ etiquetaRemitenteMensaje(mensaje) }}  <br/></p>


		        <p 
		          :class="`${ mensaje.mio == 0 ? 'time' : 'response-time time'} black--text`"
		        >{{ mensaje.fecha_creacion }}</p>

		      </div>
		    </div>
		  </span>
				</v-col>
			</v-row>
		</v-card-text>

		<div class="wa-footer-stack" :class="{ 'wa-footer-stack--wa': whatsappStyle }">
			<slot name="antes-composer"></slot>

			<v-card-actions id="sectionMessage" v-if="composerDeshabilitadoPorControl">
				<v-alert dense colored-border border="left" color="orange darken-2" class="mb-0 flex-grow-1">
					<div class="d-flex align-center flex-wrap">
						<span class="text-caption mr-2">
							{{ mensajeComposerDeshabilitado || 'La IA tiene el control. Toma el control para responder (texto, audio o archivos).' }}
						</span>
						<v-spacer></v-spacer>
						<v-btn
							v-if="mostrarAccionTomarControl"
							x-small
							color="orange darken-2"
							outlined
							:loading="cargandoAccionControl"
							@click="$emit('tomar-control')"
						>
							Tomar control
						</v-btn>
					</div>
				</v-alert>
			</v-card-actions>

			<v-card-actions id="sectionMessage" v-else-if="composerHabilitadoRh">
		  		
		  	<!-- Botones para el audio -->
				<v-btn color="red"     small @click="deleteAudio()" class="mr-2" v-if="audio" dark><v-icon>mdi-delete</v-icon></v-btn>

				<v-btn color="orange"  small @click="pauseAudio()"  class="mr-2" v-if="audio" dark><v-icon>mdi-pause</v-icon></v-btn>

				<v-btn color="blue"    small @click="playAudio()"   class="mr-2" v-if="audio" dark><v-icon>mdi-play</v-icon></v-btn>

				<v-btn color="success" small @click="sendAudio()"   class="mr-2" v-if="audio" dark><v-icon>mdi-send</v-icon></v-btn>

				<!-- Progress del audi -->
				<v-progress-linear
					v-if="audio && grabando"
					class="mt-2"
		      indeterminate
		      color="green"
		    ></v-progress-linear>

		    <!-- Cuadro de texto para enviar archivos -->
			 <v-tooltip top v-if="mostrarBotIA && analysisIAComputed && analysisIAComputed.recommendation">
				<template v-slot:activator="{ on, attrs }">
						<v-btn right plane icon v-bind="attrs" v-on="on" @click="suggestedMessagesDialog = true">
							<v-icon dark>
								mdi-robot-confused-outline
							</v-icon>
						</v-btn>
				</template>
				<span>{{ analysisIAComputed.recommendation }}</span>
			 </v-tooltip>

      
			<!-- Botón para abrir el dialogo de mensajes predeterminados -->
			<v-btn color="primary" icon @click="mensajesPredeterminadosDialog.estatus = true"
				v-if="[1, 32, 334, 3015, 718, 2574, 568].includes(getdatosUsuarioERPERP.iderp)">
				<v-icon dark>mdi-message-text-outline</v-icon>
			</v-btn>

			<v-textarea
				v-if="!audio"
				label="Escribe un mensaje aquí"
				solo
				rounded
				hide-details
				single-line
				dense
				auto-grow
				rows="1"
				v-model="message"
				:append-outer-icon="message ? 'mdi-send' : 'mdi-microphone'"
				prepend-icon="mdi-paperclip"
				@click:append-outer="message ? sendMessage() : grabarAudio()"
				@click:prepend="vistaPrevia = null, file = null, dialogArchivos = true"
				@keyup.enter="sendMessage"
			></v-textarea>
			</v-card-actions>

			<v-card-actions id="sectionMessage" v-else>
				<v-alert color="red" type="warning" v-if="chat.sucursal">
					Hola, este contacto no puede recibir mensajes, debido a que el contacto inicial proviene de la sucursal <strong>{{ chat.city }}.</strong>
				</v-alert>
	  		<v-alert color="red" type="warning" v-else>
					<template v-if="mensajeVentanaCerrada">{{ mensajeVentanaCerrada }}</template>
					<template v-else>
						Hola, este contacto ya no puede recibir mensajes, debido a que la ventana de <b>24 horas se ha cerrado</b>, en caso de requerir enviar un mensaje, favor de comunicarse con el departamento de <b>COMERCIAL</b>
					</template>
				</v-alert>
			</v-card-actions>
		</div>
	  
	  <!-- Sección para enviar un mensaje -->

	  <!-- Chip de asignación -->
	  <!-- <v-btn color="orange" tile absolute right class="mt-10" top dark v-if="asignacion && asignacion.vendedora">{{ asignacion.vendedora }}</v-btn> -->
	  
	  <!-- DIALGO PARA AGREGAR UN ARCHIVO -->
    <v-dialog
	    v-model="dialogArchivos"
	    :max-width="400"
		  @paste="pegar"
	  >
	  	<v-card class="mx-auto shadowCard" >
		    <v-card-title class="text-h6 font-weight-regular justify-space-between">
		      <span class="text-subtitle-1"> Agregar archivo </span>
		    </v-card-title>

		    <v-card-text align="center">
		      <div v-if="!file">
            <div :class="['dropZone', dragging ? 'dropZone-over' : '']" @dragenter="dragging = true" @dragleave="dragging = false">
              <div class="dropZone-info" @drag="onChange">
                <span class="fa fa-cloud-upload dropZone-title"></span>
                <span class="dropZone-title blue--text"><b>Arrastre el archivo para cargar</b></span>
                <div class="dropZone-upload-limit-info">
                  <div v-if="modoAdjuntosRh">PDF/DOC/DOCX máx. 20 MB · JPG/PNG máx. 5 MB</div>
                  <div v-else>Tamaño máximo: 40 MB</div>
                </div>
              </div>
              <input
                type="file"
                @change="onChange"
                :accept="modoAdjuntosRh ? '.pdf,.doc,.docx,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png' : undefined"
              >
            </div>
          </div>
         
          <div v-else>
          	<v-card class="elevation-0 transparent">
			        <img v-if="vistaPrevia && tipoArchivo == 2" :src="vistaPrevia" alt="Red dot" width="100%"/>
			        <div v-else-if="file && esDocumentoWord({ nombreArchivo: file.name })" class="pa-4">
			          <v-icon color="#1565c0" size="48">mdi-file-word-box</v-icon>
			          <div class="mt-2">{{ file.name }}</div>
			        </div>
			        <iframe 
			        	v-else-if="vistaPrevia && tipoArchivo == 4"
					      :src="`${vistaPrevia}#toolbar=0`" 
					      width="100%" 
					      height="300px" 
					      style="border: none;"
					    ></iframe>

			      </v-card>

			      <v-card
			      	class="mt-2"
			      >
			        <v-textarea
						    label="Escribe un mensaje aquí"
						    filled
						    rounded
						    hide-details
						    dense
						    auto-grow
						    rows="1"
						    v-model="message"
						  ></v-textarea>
			      </v-card>

          </div>
		    </v-card-text>

		    <v-card-actions>
		      <v-btn 
		      	color="black" 
		      	dark 
		      	small 
		      	tile 
		      	@click="cancelar()"
		      	absolute
		      	top
		      	right
		      	icon
		      >
		      	<v-icon small left>mdi-close</v-icon>
		      </v-btn>
		      
		      <v-spacer></v-spacer>
		      
		      <v-btn color="success" block dark small tile @click="sendMessage()">
		      	Enviar
		      	<v-icon small right> mdi-send </v-icon>
		      </v-btn>
		    
		    </v-card-actions>
		  </v-card>
		</v-dialog>

		<!-- Dialog para ver imágenes a tamaño de pantalla -->
		<v-dialog
			v-model="dialgImagen"
			fullscreen
			hide-overlay
			transition="fade-transition"
			content-class="twilio-imagen-lightbox"
		>
      <v-card class="twilio-imagen-lightbox__card" dark>
        <v-btn
          icon
          absolute
          top
          right
          class="twilio-imagen-lightbox__close"
          @click="cerrarImagen"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <div class="twilio-imagen-lightbox__stage" @click.self="cerrarImagen">
          <img
            v-if="imagenSrcDialog"
            :src="imagenSrcDialog"
            alt="Imagen"
            class="twilio-imagen-lightbox__img"
          >
        </div>
      </v-card>
    </v-dialog>

    <!-- VER PDF: se carga solo al abrir el diálogo -->
    <v-dialog v-model="dialogPDF" :max-width="modoAdjuntosRh ? '920px' : '650px'" persistent>
      <v-card class="elevation-0">
        <embed
          v-if="pdfSrcDialog"
          :src="pdfSrcDialog"
          :width="modoAdjuntosRh ? 900 : 650"
          height="700"
          type="application/pdf"
        >
        <v-card-text v-else class="text-center grey--text">No se pudo abrir el PDF</v-card-text>
        <v-card-actions class="pt-0" >
          <v-spacer></v-spacer>
          <!-- Guardar la información  -->
          <v-btn
            color="error" 
            dark 
            class="elevation-6" 
            block
            @click="dialogPDF = false"
          >Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogMicrofono"
      persistent
      max-width="490"
    >
      <v-card>
        <v-card-title class="text-h5">
          Conectar micrófono
        </v-card-title>
        <v-card-text>
        	Google Chrome:<br/>
					Ve a Configuración > Privacidad y seguridad > Configuración del sitio > Micrófono.
					<br/>Busca tu sitio en la lista y cambia la opción a "Permitir".
					<br/><br/>
					Firefox:
					<br/>Ve a Preferencias > Privacidad y seguridad > Permisos > Micrófono.
					Administra los sitios web que tienen acceso.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="#017561"
            dark
            rounded
            @click="dialogMicrofono = false"
          >
            Enterado
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogAudio"
      persistent
      max-width="490"
    >
      <v-card>
        <v-card-title class="text-h5">
        </v-card-title>

        <v-card-text class="mt-6">

      		<v-progress-linear
			      :indeterminate="grabando"
			      color="green"
			      height="25"
			      rounded
			      :value="grabando ? 0 : 100"
			    >
			    	<v-icon color="white" small>mdi-microphone</v-icon>
			    </v-progress-linear>
      		<audio v-if="audioVisible" :src="audioURL" controls></audio>


        	<div class="text-center mt-6" align="center">

        		<v-btn 
        			color="grey"
        			class="mr-2"
        			small
        			fab
        			@click="deleteAudio( )"
        		>
        			<v-icon color="white">mdi-delete</v-icon>
        		</v-btn>

        		<v-btn 
        			class="mr-2"
        			color="red"
        			small
        			fab
          		v-if="grabando == true"
        			@click="pauseAudio( )"
        		>
        			<v-icon color="white">mdi-stop</v-icon>
        		</v-btn >

        		<v-btn 
        			class="mr-2"
        			color="red"
        			small
        			fab
          		v-else
        			@click="playAudio( )"
        		>
        			<v-icon color="white">mdi-play</v-icon>
        		</v-btn>

        		<v-btn 
        			color="green"
        			small
        			fab
        			@click="sendAudio()"
        		>
        			<v-icon color="white">mdi-send</v-icon>
        		</v-btn>
        	</div>

        </v-card-text>
        <v-card-actions>
          <v-btn 
          	icon
          	absolute
          	top
          	right
          	@click="deleteAudio( )"
          >
        		<v-icon>mdi-close</v-icon>
        	</v-btn>
        </v-card-actions>	
      </v-card>
    </v-dialog>

    <v-menu
      v-model="verMenu"
      :position-x="x"
      :position-y="y"
      absolute
      offset-y
    >
      <v-list dense>
        <v-list-item
          v-for="(item, index) in opciones"
          :key="index"
          @click="abrirModalUsuarios( item )"
        >
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <MensajesPredeterminadosChat
      v-if="mensajesPredeterminadosDialog.estatus"
      :mensajesPredeterminadosDialog="mensajesPredeterminadosDialog"
			:mensajeSeleccionado="mensajeSeleccionado"
			@enviarMensaje="enviarMensaje"
    />

    <ModalContactos
    	v-if="dialogContactos.estatus"
    	:dialogContactos="dialogContactos"
    	:chats="chats"
    	:mensajeReenviar="mensajeReenviar"
		:numeroTwilio="numeroTwilio"
    	@verChat="verChat"
    />

		<suggested-messages-dialog
			v-if="analysisIAComputed && analysisIAComputed.suggested_messages"
      :suggested-messages="analysisIAComputed.suggested_messages || []"
			:suggestedMessagesDialog="suggestedMessagesDialog"
			@closeSuggestedMessagesDialog="closeSuggestedMessagesDialog"
			@showSnackbar="showSnackbar"
    />

		<v-snackbar v-model="snackbar" :timeout="2000">{{ snackbarText }}</v-snackbar>
	  <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>
	</div>
</template>

<script>
	import axios from 'axios';
	import { beginDeferKpiNotifications, endDeferKpiNotifications } from '@/utils/socketKpiNotificationDefer'

  import RecordRTC from 'recordrtc';
	// Componentes
  import Alerta                				from '@/components/alertas/Alerta.vue'
  import carga                 				from '@/components/alertas/carga.vue';
  import AgregarArchivo        				from '@/components/whatsapp/AgregarArchivo.vue'
  import ModalContactos        				from '@/components/whatsapp/ModalContactos.vue'
  import SuggestedMessagesDialog 			from '@/components/whatsapp/SuggestedMessagesDialog.vue'
	import MensajesPredeterminadosChat 	from '@/components/whatsapp/MensajesPredeterminadosChat.vue'
  import ComentariosProspecto        from '@/components/ComentariosProspecto.vue'
  import validarErrores        				from '@/mixins/validarErrores'
  
  import {mapGetters, mapActions } from 'vuex'
	import { Camera } from '@capacitor/camera';

	export default {

		components:{
      Alerta,
      carga,
      AgregarArchivo,
      ModalContactos,
	  	SuggestedMessagesDialog,
			MensajesPredeterminadosChat,
      ComentariosProspecto
    },

    mixins: [ validarErrores ],

		props:{
			mensajes: { default: undefined },
			alumno: { default: undefined },
			wha: { default: undefined },
			chat: { default: undefined },
			verTodosLosMensajes: { default: undefined },
			asignacion: { default: undefined },
			numeroTwilio: { default: undefined },
			chats: { default: undefined },
			analysisIA: { default: undefined },
			mostrarBotIA: { default: undefined },
			/** Base URL medias del prospecto (mio=0). En Agente/INBI: escuelakpi. */
			urlMediaProspecto: { type: String, default: '' },
			/** Base URL medias del asesor (mio=1). */
			urlMediaAsesor: { type: String, default: '' },
			whatsappStyle: { type: Boolean, default: false },
			/** Endpoint de envío (default ventas). RH: twilio-rh.enviar */
			endpointEnviar: { type: String, default: 'twilio.send.message' },
			/**
			 * Modo adjuntos RH: PDF/DOC/DOCX/JPG/PNG con límites estrictos.
			 * No altera el flujo de ventas si permanece false.
			 */
			modoAdjuntosRh: { type: Boolean, default: false },
			/** Texto cuando la ventana 24h está cerrada (opcional). */
			mensajeVentanaCerrada: { type: String, default: '' },
			/** Twilio RH: no bloquear el composer por ventana 24h de WhatsApp. */
			ignorarVentana24h: { type: Boolean, default: false },
			/** Bloquea texto/audio/archivos mientras la IA tiene el control */
			composerDeshabilitadoPorControl: { type: Boolean, default: false },
			mensajeComposerDeshabilitado: { type: String, default: '' },
			mostrarAccionTomarControl: { type: Boolean, default: false },
			cargandoAccionControl: { type: Boolean, default: false },
		},

		data: () => ({
			snackbar: false,
			snackbarText: "",
	  	suggestedMessagesDialog:false,
      message: '',
      dialogArchivos: false,
      archivos:null,
      vistaPrevia: null,
      file: '',
      dragging: false,
			enviandoMensajeRh: false,
      dialgImagen:false,
			// url/url2 ahora son computed (props urlMediaProspecto / urlMediaAsesor)

			fullscreen: false,
			pdf:null,
			dialogPDF: false,
			pdfBlobUrls: {},
			
			imagen: null,
			grabando: false,
			mediaRecorder: null,
			chunks: [],
			audio: false,
			recording: false,
      blob: null,
      mp3Data: [],
      audioContext: null,
      audioInput: null,
      scriptProcessor: null,
      mp3Encoder: null,
      recorder: null,
      buffer: null,
      audioPath:null,

      longitudMensajes: 0,
      _ultimoMensajeScrollKey: null,

      tipoArchivo: 0,
      clipboardContent: '',

      dialogMicrofono: false,

      dialogGrabacion: false,

			socketKpiDeferRecording: false,

      // Diseño para el audio
      mediaRecorder: null,
      audioStream: null,
      analyser: null,
      canvasCtx: null,

      audioURL: null,

      blobs: [], // Aquí se guardarán los segmentos de audio
    	combinedBlob: null, // Aquí se almacenará el audio combinado
    	audioVisible: false,
    	chunks: [], // Usaremos chunks en lugar de blobs

    	verMenu: false,
      x: 0,
      y: 0,
      opciones: [
        { title: 'Reenviar' },
        { title: 'Descargar' },
      ],

      dialogAudio: false,

      documentacion: [
      	'PDF FAST-INTENSIVO.pdf',
		    'PDF FAST-ONLINE SABATINO.pdf',
		    'PDF FAST-ONLINE.pdf',
		    'PDF FAST-SABATINO.pdf',
		    'PDF - INBI ADULTS ONLINE.pdf',
		    'PDF - INBI ADULTS ONLINE SABATINO.pdf',
		    'PDF - INBI ADULTS.pdf',
		    'PDF - INBI ADULTS SABATINO.pdf',
		    'PDF - INBI KIDS.pdf',
		    'PDF - INBI TEENS SABATINO.pdf',
		    'PDF - INBI TEENS.pdf',
		    'preventa editable.pdf'
		  ],

      mensajeReenviar: null,
      dialogContactos:{
      	estatus: false
      },

			mensajesPredeterminadosDialog:{
				estatus: false
			},

			mensajeSeleccionado: null,
			mediaVisibles: {},
		}),

		computed:{

			...mapGetters('login', ['getdatosUsuarioERPERP']),
			...mapGetters('twilio', ['getConversacionesM','getConversacionesC', 'getConversacionesG']),
			/** Prospecto (mio=0): por defecto FAST; Agente/INBI debe sobreescribir a escuelakpi. */
			url() {
				const override = String(this.urlMediaProspecto || '').trim()
				return override || 'https://testfast.club/imagenes-whatsapp/'
			},
			/** Asesor (mio=1) */
			url2() {
				const override = String(this.urlMediaAsesor || '').trim()
				return override || 'https://escuelakpi.club/imagenes-whatsapp/'
			},
			analysisIAComputed(){
				return this.analysisIA
			},
			composerHabilitadoRh(){
				if (this.ignorarVentana24h) return true
				return this.chat && Number(this.chat.tiemporestante) > 0
			},
			filterMensajes(){

        let mensajes = this.mensajes
        const len = mensajes.length
        const ultimoKey = this.ultimoMensajeKeyLista(mensajes)

				if (this.longitudMensajes !== len || this._ultimoMensajeScrollKey !== ultimoKey) {
					const crecioPorHistorial = len > this.longitudMensajes
            && ultimoKey === this._ultimoMensajeScrollKey

					this.longitudMensajes = len
					this._ultimoMensajeScrollKey = ultimoKey

					if (!crecioPorHistorial) {
						this.$nextTick(() => {
							requestAnimationFrame(() => {
								const el = document.getElementById('scroll-target')
								if (el) el.scrollTop = el.scrollHeight
							})
						})
					}
				}

        return mensajes
      },

      bloqueo( ){
      	return this.chat.idetiquetas == 6 ? true : false
      },
      /** Dialog imagen: filename, http, data: o blob: */
      imagenSrcDialog() {
        const v = String(this.imagen || '')
        if (!v) return ''
        if (/^(https?:|data:|blob:)/i.test(v)) return v
        if (v.startsWith('/api-rh/') || v.startsWith('/twilio-rh.')) {
          return this.resolverUrlMediaRh(v)
        }
        return String(this.url || '').replace(/\/?$/, '/') + v.replace(/^\//, '')
      },
      pdfSrcDialog() {
        const v = String(this.pdf || '')
        if (!v) return ''
        if (/^(https?:|data:|blob:)/i.test(v)) return v
        // RH: URL ya resuelta (/api-rh/…) o relativa firmada — no anteponer CDN ventas
        if (v.startsWith('/api-rh/') || v.startsWith('/twilio-rh.')) {
          return this.resolverUrlMediaRh(v)
        }
        const base = String(this.url2 || this.url || '').replace(/\/?$/, '/')
        return base + v.replace(/^\//, '')
      },
		},

		created( ) {
			this.longitudMensajes = this.mensajes.length
		},

		mounted() {
	    // Agrega el listener solo cuando el componente está montado
	    window.addEventListener("keydown", this.handlePaste);
			this.precargarPdfsRh()
	  },

	  beforeDestroy() {
	    // Elimina el listener al destruir el componente
	    window.removeEventListener("keydown", this.handlePaste);
	    this._stopDeferKpiNotifsWhileRecording()
			this.revocarPdfBlobsRh()
	  },


		watch: {
			'chat.usuario' () {
				this.mediaVisibles = {}
				this.longitudMensajes = 0
				this._ultimoMensajeScrollKey = null
				this.revocarPdfBlobsRh()
			},
			mensajes() {
				this.precargarPdfsRh()
			},
		},

		whatch: {

			mensajes( ){

				console.log('Hubo un cambio')
			},


			dialogArchivos( val ){

				console.log( val )

			}
		},

		mounted( ){
  		this.canvas = this.$refs.audioCanvas;
  		console.log( this.canvas )
		},

		methods: {
			etiquetaRemitenteMensaje (mensaje) {
				const nombre = String(mensaje && mensaje.nombre_completo || '').trim()
				if (nombre) return nombre
				// Mensajes salientes sin join (bot / API Twilio / iderp inválido)
				return Number(mensaje && mensaje.mio) === 1 ? 'Sistema' : ''
			},

			ultimoMensajeKeyLista (lista) {
				if (!lista || !lista.length) return null
				const m = lista[lista.length - 1]
				return m.idmensajes || m.messageSid || `${m.fecha_creacion}-${m.mensaje}`
			},

			mensajeKey (mensaje, i) {
				return mensaje.idmensajes || mensaje.messageSid || `msg-${i}-${mensaje.fecha_creacion}`
			},

			mensajeMediaKey (mensaje, i) {
				return this.mensajeKey(mensaje, i)
			},

			esMediaVisible (mensaje, i) {
				return !!this.mediaVisibles[this.mensajeMediaKey(mensaje, i)]
			},

			mostrarMedia (mensaje, i) {
				this.$set(this.mediaVisibles, this.mensajeMediaKey(mensaje, i), true)
			},

			...mapActions('twilio', ['guardarConversacionesM','guardarConversacionesC', 'guardarConversacionesG']),

			_startDeferKpiNotifsWhileRecording () {
				if (this.socketKpiDeferRecording) return
				this.socketKpiDeferRecording = true
				beginDeferKpiNotifications()
			},

			_stopDeferKpiNotifsWhileRecording () {
				if (!this.socketKpiDeferRecording) return
				this.socketKpiDeferRecording = false
				endDeferKpiNotifications()
			},

			initialize () {
				this.cargar = true
				this.usuarios = []
				return this.$http.get('whatsapp.usuarios').then(response=>{
					this.usuarios = response.data
					this.cargar      = false
				}).catch( error =>{
					this.validarError( error.response.data.message )
				}).finally( () => { this.cargar = false })
			},

			show (mensaje,e) {
				this.mensajeReenviar = mensaje
				console.log( this.mensajeReenviar )
        e.preventDefault()
        this.verMenu = false
        this.x = e.clientX
        this.y = e.clientY
        this.$nextTick(() => {
          this.verMenu = true
        })
      },

			handlePaste(event) {
				const clipboardData = event.clipboardData || (event.originalEvent && event.originalEvent.clipboardData)
				if (!clipboardData) return

				const imageFile = this.getClipboardImageFile(clipboardData)

				if (imageFile) {
					event.preventDefault()
					this.vistaPrevia    = null
					this.file           = null
					this.dialogArchivos = true
					this.createFile(imageFile)
					return
				}

				const text = clipboardData.getData('text/plain')

				if (text && !this.isEditablePasteTarget(event.target)) {
					event.preventDefault()
					this.message = text
				}
	    },

			enviarMensaje( mensaje ){
				console.log( mensaje )

				mensaje['usuario']   = this.chat.usuario // twilio desde donde se envía el mensaje
				mensaje['twilio']    = this.numeroTwilio // twilio del usuario
				mensaje['iderp']     = this.getdatosUsuarioERPERP.iderp
				mensaje['mio']       = 1
				mensaje['MediaUrl0'] = mensaje.archivo

      	return this.$http.post('twilio.reenviar.message', mensaje ).then( ( response )=>{

      		this.$emit('verChat', this.chat )
      		this.chat = null

      		this.mensajesPredeterminadosDialog.estatus = false
      		
					// Limpiar dialogo de archivos
          this.cargar  = false

        }).catch( error =>{
        	console.log( error )
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
			},

			sendMessage( value ){

				if (this.modoAdjuntosRh && this.enviandoMensajeRh) {
					return
				}

				let etapa = this.chat.idetapa

				// validar la etapa
				if( this.file ){

					// Existe un archivos, hay que validar el nombre del archivo, para poder saber siiiiiii el nombre es uno de los validos
					if( this.documentacion.includes( this.file.name ) ){

						etapa = 4

					}
				}

				const textoTrim = String(this.message || '').trim()
				if (this.modoAdjuntosRh && !textoTrim && !this.file) {
					this.validarError('Escribe un mensaje o adjunta un archivo')
					return
				}
				if (this.modoAdjuntosRh && this.audio) {
					this.validarError('Audio no permitido en Twilio RH')
					return
				}


        // Preparamos el mensaje a enviar
      	var formData = new FormData();
	      formData.append("from"           , this.numeroTwilio );
	      formData.append("body"           , this.message );
	      formData.append("to"             , this.chat.usuario );
	      formData.append("audio"          , this.audio ? '1' : '0' );
	      formData.append("rutaAudio"      , this.audioPath );

	      // Prospectos
	      formData.append("idprospectos"   , this.chat.idprospectos );
	      formData.append("idetapa"        , etapa );
	      formData.append("iderp"          , this.getdatosUsuarioERPERP.iderp );

	      // Si hay un archivo, se agrega el archivo al formData que se enviara para que twilio lo procese
	      if( this.file ){ formData.append("file", this.file ) }
	      
	      let type = 1
	      // Sacar la validación del tipo de archivo que se está enviando 
	      	      
	      if( this.file && !this.audio){


	      	const nombreSplite = this.file.name.split('.')

	      	const exstension = nombreSplite[ nombreSplite.length -1 ]

	      	// Validamos si son imagenes 
	      	type = ['jpg','jpeg','png','webp','svg','JPG','JPEG','PNG','WEBP','SVG'].includes( exstension ) ? 2 : type

	      	// Validamos si son PDF
	      	type = ['PDF','pdf'].includes( exstension ) ? 4 : type

	      	// Word (RH y también tipo documento genérico)
	      	type = ['doc','docx','DOC','DOCX'].includes( exstension ) ? 4 : type

	      	// Validar si es video
	      	type = ['mp4','mov','avi','MOV','AVI'].includes( exstension ) ? 5 : type

	      }

	      // Validar si se envió un audio
	      type = this.audio ? 3 : type

	      const textoEnviado = this.message
	      const twilioLinea = this.numeroTwilio || this.chat.numeroTwilio
	      const previewLocal = this.vistaPrevia || null
	      const nombreLocal = this.file && this.file.name ? this.file.name : ''
	      const blobLocal = (type === 4 && this.file) ? URL.createObjectURL(this.file) : ''
	      const fechaPreview = new Date().toISOString().replace('T', ' ').slice(0, 19)
				const esWordLocal = this.modoAdjuntosRh && /\.(docx?)$/i.test(nombreLocal)

	      // Hacemos la simulación de mensajes
	      this.mensajes.push({
					idmensajes: 0,
					idusuarios: 0,
					usuario: this.chat.usuario,
					mensaje: textoEnviado,
					twilio: twilioLinea,
					mio: 1,
					iderp: this.getdatosUsuarioERPERP.iderp,
					nombre_completo: this.getdatosUsuarioERPERP.nombre_completo
						|| this.getdatosUsuarioERPERP.nombre
						|| '',
					fecha_creacion: fechaPreview,
					type,
					MediaUrl0: "",
					messageSid: "41135435165435135135315",
					imagenFake: type === 2 ? previewLocal : (blobLocal || previewLocal),
					nombreArchivo: nombreLocal,
					es_documento_word: esWordLocal,
					media_nombre: nombreLocal || null,
					audioFake : this.file,
					fake      : true
	      })

	    	// Enviamos el chat hasta abajo
	      this.scrolear( )

	      // Limpiamos todo
      	this.cancelar( )

	      // Actualización inmediata en lista (sin esperar backend): quita reasignado + sin leer
	      if (this.chat) {
	      	this.chat.idetapa = ['1',1,'2',2,'7',7].includes( this.chat.idetapa ) ? 5 : etapa
	      	this.chat.reasignado = 0
	      	this.chat.sinleer = 0
	      	this.chat.mio = 1
	      	this.chat.mensaje = textoEnviado
	      	this.chat.fecha_ultimo_mensaje = fechaPreview
	      }
	      this.$emit('validayGuardaMensajes', {
	      	mensaje: textoEnviado,
	      	type,
	      	mio: 1,
	      	sinleer: 0,
	      	reasignado: 0,
	      	fecha_ultimo_mensaje: fechaPreview,
	      })

				if (this.modoAdjuntosRh) {
					this.enviandoMensajeRh = true
					this.cargar = true
				}

	      // Se envía el mensaje al backend en paralelo
        return this.$http.post(this.endpointEnviar || 'twilio.send.message', formData ).then( ( response )=>{

        	this.chat.idetapa = ['1',1,'2',2,'7',7].includes( this.chat.idetapa ) ? 5 : etapa
        	this.message = textoEnviado
          const data = response && response.data ? response.data : {}
          const mediaName = data.media
            || ((data.resultados || []).find((r) => r && r.tipo === 'media' && r.ok) || {}).media
          if (mediaName) {
            const last = this.mensajes[this.mensajes.length - 1]
            if (last && last.fake) {
              this.$set(last, 'MediaUrl0', mediaName)
            }
          }
					if (this.modoAdjuntosRh && data.parcial) {
						this.validarError('Envío parcial: revisa texto y archivo por separado')
					}
        	// Emitimos los mensajes a la pestaña inicial para validar la información
					this.$emit('verChat', this.chat )
					this.$emit('validayGuardaMensajes')
					this.message = ''

      		// Limpiar dialogo de archivos
          this.cargar  = false


        }).catch( error =>{
        	console.log( error )
					const last = this.mensajes[this.mensajes.length - 1]
					if (last && last.fake) {
						this.$set(last, '_envioFallido', true)
					}
          this.validarError( error.response && error.response.data && error.response.data.message
						? error.response.data.message
						: 'Error al enviar' )
        }).finally( () => {
					this.cargar = false
					if (this.modoAdjuntosRh) this.enviandoMensajeRh = false
				})
			},

      cancelar( ){
				this._stopDeferKpiNotifsWhileRecording()
      	this.chunks          = []
      	this.vistaPrevia     = null
	      this.archivos        = null
	      this.file            = '';
      	this.dialogArchivos  = false
				this.message         = ''
				this.audio           = false
				this.grabando        = false
				this.imagen          = null
				this.mediaRecorder   = null
				this.chunks          = []
				this.recording       = false
	      this.blob            = null
	      this.mp3Data         = []
	      this.audioContext    = null
	      this.audioInput      = null
	      this.scriptProcessor = null
	      this.mp3Encoder      = null
	      this.recorder        = undefined
	      this.buffer          = null
	      this.audioPath       = null
        this.dialogGrabacion = false
        this.dialogAudio     = false
      },

      getBase64(file) {
	      var me = this
	      var reader = new FileReader();
	      reader.readAsDataURL(file);
	      reader.onload = () => {
	        
		      if( file ){

		      	const nombreSplite = file.name.split('.')

		      	const exstension = nombreSplite[ nombreSplite.length -1 ]

		      	// Validamos si son imagenes 
		      	this.tipoArchivo = ['jpg','jpeg','png','webp','svg','JPG','JPEG','PNG','WEBP','SVG'].includes( exstension ) ? 2 : this.tipoArchivo

		      	// Validamos si son PDF / Word
		      	this.tipoArchivo = ['PDF','pdf','doc','docx','DOC','DOCX'].includes( exstension ) ? 4 : this.tipoArchivo

		      }

	        this.vistaPrevia = reader.result

	      };
	    },

			onChange(e) {
	      var files = e.target.files || e.dataTransfer.files;
	      if (!files.length) {
	        this.dragging = false;
	        return;
	      }
	      
	      this.createFile(files[0]);
	    },

	    createFile(file) {
				if (this.modoAdjuntosRh) {
					const nombre = String((file && file.name) || '')
					const parts = nombre.split('.')
					const ext = parts.length > 1 ? String(parts[parts.length - 1]).toLowerCase() : ''
					const permitidas = ['pdf', 'doc', 'docx', 'jpg', 'jpeg', 'png']
					if (!permitidas.includes(ext)) {
						this.validarError('Formato no permitido. Usa PDF, DOC, DOCX, JPG o PNG')
						this.dragging = false
						return
					}
					const esImg = ['jpg', 'jpeg', 'png'].includes(ext)
					const max = esImg ? 5000000 : 20000000
					if (file.size > max) {
						this.validarError(esImg
							? 'Imagen demasiado grande (máx. 5 MB)'
							: 'Documento demasiado grande (máx. 20 MB)')
						this.dragging = false
						return
					}
					this.tipoArchivo = esImg ? 2 : 4
				} else if (file.size > 40000000) {
	        alert('please check file size no over 40 MB.')
	        this.dragging = false;
	        return;
	      }
	      
	      this.file = file;
	      this.getBase64(this.file)
	      this.dragging = false;
	    },

	    verImagen( value ){
        this.imagen      = value
        this.dialgImagen = true
      },

      cerrarImagen() {
        this.dialgImagen = false
        this.fullscreen = false
      },

      esAmbientePruebas() {
        if (process.env.VUE_APP_ENV === 'staging') return true
        return typeof window !== 'undefined' && /pruebas/i.test(window.location.hostname)
      },

      baseApiMediaLocal() {
        const api = String((this.$http && this.$http.defaults && this.$http.defaults.baseURL) || '').replace(/\/?$/, '/')
        return api ? `${api}imageneswhatsapplocal/` : ''
      },

      basesMediaCandidatas(mensaje = {}) {
        const list = []
        const add = (u) => {
          const s = String(u || '').trim()
          if (!s) return
          const norm = s.endsWith('/') ? s : `${s}/`
          if (!list.includes(norm)) list.push(norm)
        }
        if (this.esAmbientePruebas()) add(this.baseApiMediaLocal())
        add(Number(mensaje.mio) === 1 ? this.url2 : this.url)
        add(this.url2)
        add(this.url)
        add('https://escuelakpi.club/imagenes-whatsapp/')
        add('https://testfast.club/imagenes-whatsapp/')
        if (!this.esAmbientePruebas()) add(this.baseApiMediaLocal())
        return list
      },

      /** URL absoluta del media. En pruebas prueba disco del API; si falla, CDN. */
      srcMediaMensaje(mensaje = {}) {
        if (mensaje && mensaje._useFake && mensaje.imagenFake) return mensaje.imagenFake
        if (mensaje && mensaje.fake && mensaje.imagenFake) return mensaje.imagenFake
				if (this.modoAdjuntosRh && mensaje && mensaje.idmensajes && this.pdfBlobUrls[mensaje.idmensajes]) {
					return this.pdfBlobUrls[mensaje.idmensajes]
				}
				if (mensaje && mensaje.media_url) {
					return this.resolverUrlMediaRh(mensaje.media_url)
				}
        const file = mensaje && mensaje.MediaUrl0
        if (file) {
          if (/^(https?:|data:|blob:)/i.test(String(file))) return String(file)
					if (this.modoAdjuntosRh && mensaje.idmensajes) {
						return this.urlMediaSesionRh(mensaje.idmensajes)
					}
          const bases = this.basesMediaCandidatas(mensaje)
          const idx = Number(mensaje._mediaBaseIdx) || 0
          const base = bases[idx] || bases[0] || ''
          return String(base).replace(/\/?$/, '/') + String(file).replace(/^\//, '')
        }
        if (mensaje && mensaje.imagenFake) return mensaje.imagenFake
        return ''
      },

			baseApiRh() {
				const http = this.$http
				return String(
					(http && http.defaults && http.defaults.baseURL)
					|| (http && http.options && http.options.root)
					|| '/api-rh/'
				).replace(/\/?$/, '/')
			},

			urlMediaSesionRh(idmensajes) {
				const id = Number(idmensajes)
				if (!id) return ''
				return this.baseApiRh() + 'twilio-rh.media.mensaje/' + id
			},

			/**
			 * RH: media_url relativa o de otro host → proxy del front (local /api-rh, prod kpi-proxy).
			 * Evita iframe a escuelakpi.club sin /kpi (nginx 404).
			 */
			resolverUrlMediaRh(raw) {
				const s = String(raw || '').trim()
				if (!s) return ''
				if (!this.modoAdjuntosRh) return s
				const apiBase = this.baseApiRh()
				const reescribir = (pathname, search) => {
					let path = String(pathname || '')
					path = path.replace(/^\/kpi-proxy\/?/, '/')
					path = path.replace(/^\/kpi\/?/, '/')
					path = path.replace(/^\/api-rh\/?/, '/')
					if (!/twilio-rh\.media\./.test(path)) return ''
					return apiBase + path.replace(/^\//, '') + (search || '')
				}
				if (s.startsWith('/twilio-rh.')) {
					return apiBase + s.replace(/^\//, '')
				}
				if (s.startsWith('/api-rh/')) return s
				try {
					const u = new URL(s, typeof window !== 'undefined' ? window.location.origin : 'http://127.0.0.1')
					const viaProxy = reescribir(u.pathname, u.search)
					if (viaProxy) return viaProxy
					if (u.hostname === '127.0.0.1' || u.hostname === 'localhost') {
						return apiBase + String(u.pathname || '').replace(/^\//, '') + (u.search || '')
					}
				} catch (e) { /* noop */ }
				return s
			},

			revocarPdfBlobsRh() {
				const map = this.pdfBlobUrls || {}
				Object.keys(map).forEach((k) => {
					try { URL.revokeObjectURL(map[k]) } catch (e) { /* noop */ }
				})
				this.pdfBlobUrls = {}
			},

			precargarPdfsRh() {
				if (!this.modoAdjuntosRh) return
				const list = this.mensajes || []
				for (let i = 0; i < list.length; i++) {
					const m = list[i]
					if (!m || !m.idmensajes) continue
					const ext = this.extMediaRh(m)
					const esPdf = ext === 'pdf' || Number(m.type) === 4
					if (!esPdf || this.esDocumentoWord(m)) continue
					this.cargarPdfBlobRh(m)
				}
			},

			cargarPdfBlobRh(mensaje = {}) {
				if (!this.modoAdjuntosRh || !mensaje || !mensaje.idmensajes) {
					return Promise.resolve('')
				}
				const id = mensaje.idmensajes
				if (this.pdfBlobUrls[id]) return Promise.resolve(this.pdfBlobUrls[id])
				if (this._cargandoPdfBlob && this._cargandoPdfBlob[id]) {
					return this._cargandoPdfBlob[id]
				}
				if (!this._cargandoPdfBlob) this._cargandoPdfBlob = {}
				const mime = (mensaje.media_mime) || 'application/pdf'
				const p = this.$http.get(`twilio-rh.media.mensaje/${id}`, { responseType: 'blob' })
					.then((response) => {
						const blob = new Blob([response.data], { type: mime })
						const href = URL.createObjectURL(blob)
						this.$set(this.pdfBlobUrls, id, href)
						return href
					})
					.catch(() => '')
					.finally(() => {
						if (this._cargandoPdfBlob) delete this._cargandoPdfBlob[id]
					})
				this._cargandoPdfBlob[id] = p
				return p
			},

      probarSiguienteBaseMedia(mensaje) {
        if (!mensaje) return false
        const max = this.basesMediaCandidatas(mensaje).length
        const idx = Number(mensaje._mediaBaseIdx) || 0
        if (idx + 1 < max) {
          this.$set(mensaje, '_mediaBaseIdx', idx + 1)
          return true
        }
        this.$set(mensaje, '_mediaFallido', true)
        if (mensaje.imagenFake && !mensaje._useFake) {
          this.$set(mensaje, '_useFake', true)
        }
        return false
      },

      onPdfFrameLoad(evt, mensaje) {
        const frame = evt && evt.target
        if (!frame || !mensaje) return
        if (this.modoAdjuntosRh) return
        try {
          const doc = frame.contentDocument
          if (!doc) return
          const text = String((doc.title || '') + ' ' + ((doc.body && doc.body.innerText) || ''))
          if (/404|Not Found|nginx/i.test(text)) {
            this.probarSiguienteBaseMedia(mensaje)
          }
        } catch (e) {
          // cross-origin: el host respondió (CDN)
        }
      },

      srcPdfPreview(mensaje = {}) {
				if (this.modoAdjuntosRh) {
					const blob = mensaje && mensaje.idmensajes && this.pdfBlobUrls[mensaje.idmensajes]
					if (!blob) return ''
					return `${blob}#page=1&toolbar=0&navpanes=0&scrollbar=0`
				}
        const src = this.srcMediaMensaje(mensaje)
        if (!src) return ''
        if (src.includes('#')) return src
        return `${src}#page=1&toolbar=0&navpanes=0&scrollbar=0`
      },

      nombreArchivoMedia(mensaje = {}) {
        if (mensaje.media_nombre) return String(mensaje.media_nombre)
        if (mensaje.nombreArchivo) return String(mensaje.nombreArchivo)
        const raw = String((mensaje && mensaje.MediaUrl0) || '')
        if (!raw) return 'Documento'
        try {
          const noQuery = raw.split('?')[0]
          const name = noQuery.split('/').pop() || noQuery
          return decodeURIComponent(name)
        } catch (e) {
          return 'Documento'
        }
      },

			esDocumentoWord(mensaje = {}) {
				if (mensaje && mensaje.es_documento_word) return true
				const n = String(
					(mensaje && (mensaje.media_nombre || mensaje.nombreArchivo || mensaje.MediaUrl0)) || ''
				).toLowerCase()
				return /\.(docx?)(\?|$)/i.test(n)
			},

			extMediaRh(mensaje = {}) {
				const n = String(this.nombreArchivoMedia(mensaje) || '').toLowerCase()
				const m = n.match(/\.([a-z0-9]+)(?:\?|$)/)
				return m ? m[1] : ''
			},

			puedeAnalizarCvRh(mensaje = {}) {
				if (!this.modoAdjuntosRh || !mensaje || !mensaje.idmensajes) return false
				if (Number(mensaje.mio) === 1) return false
				if (mensaje.media_estado === 'fallido') return false
				const ext = this.extMediaRh(mensaje)
				return ext === 'pdf' || ext === 'docx'
			},

			esDocAntiguoRh(mensaje = {}) {
				return this.modoAdjuntosRh && Number(mensaje.mio) !== 1 && this.extMediaRh(mensaje) === 'doc'
			},

			emitirAnalizarCv(mensaje = {}) {
				if (!this.puedeAnalizarCvRh(mensaje)) return
				this.$emit('analizar-cv', mensaje)
			},

			etiquetaMetaMedia(mensaje = {}) {
				const parts = []
				if (mensaje.media_mime) parts.push(String(mensaje.media_mime).split(';')[0])
				if (mensaje.media_bytes != null) {
					const b = Number(mensaje.media_bytes)
					if (b >= 1000000) parts.push(`${(b / 1000000).toFixed(1)} MB`)
					else if (b >= 1000) parts.push(`${Math.round(b / 1000)} KB`)
					else parts.push(`${b} B`)
				}
				return parts.join(' · ')
			},

			descargarMediaMensaje(mensaje = {}) {
				if (this.modoAdjuntosRh && mensaje.idmensajes) {
					const url = `twilio-rh.media.mensaje/${mensaje.idmensajes}`
					return this.$http.get(url, { responseType: 'blob' }).then((response) => {
						const blob = new Blob([response.data], {
							type: (mensaje.media_mime) || 'application/octet-stream',
						})
						const href = URL.createObjectURL(blob)
						const a = document.createElement('a')
						a.href = href
						a.download = this.nombreArchivoMedia(mensaje)
						a.click()
						URL.revokeObjectURL(href)
					}).catch(() => {
						const signed = this.srcMediaMensaje(mensaje)
						if (signed) window.open(signed, '_blank', 'noopener')
						else this.validarError('No se pudo descargar el archivo')
					})
				}
				const src = this.srcMediaMensaje(mensaje)
				if (src) window.open(src, '_blank', 'noopener')
			},

      onImgMediaError(mensaje) {
        if (this.modoAdjuntosRh) {
          // RH: no reintentar bases de ventas/CDN; la URL firmada ya viene del API.
          this.$set(mensaje, '_mediaFallido', true)
          return
        }
        if (this.probarSiguienteBaseMedia(mensaje)) return
        if (mensaje && mensaje.imagenFake && !mensaje._useFake) {
          this.$set(mensaje, '_useFake', true)
        }
      },

      /** Texto visible de nota de voz (Whisper / error), sin la marca técnica. */
      textoTranscripcionAudio(mensaje = {}) {
        const raw = String((mensaje && mensaje.mensaje) || '').trim()
        if (!raw) return ''
        return raw
          .replace(/\n*\s*\[Audio de WhatsApp\]\s*$/i, '')
          .trim()
      },

      mimeAudioDesdeNombre(nombre = '') {
        const n = String(nombre || '').toLowerCase()
        if (n.endsWith('.mp3') || n.endsWith('.mpeg')) return 'audio/mpeg'
        if (n.endsWith('.m4a') || n.endsWith('.mp4')) return 'audio/mp4'
        if (n.endsWith('.wav')) return 'audio/wav'
        if (n.endsWith('.webm')) return 'audio/webm'
        return 'audio/ogg'
      },

      onAudioError(mensaje) {
        if (mensaje && typeof mensaje === 'object') {
          this.$set(mensaje, '_audioError', true)
        }
      },

      verPDF( value ){
        if (value && typeof value === 'object') {
					if (this.modoAdjuntosRh && value.idmensajes) {
						this.dialogPDF = true
						this.pdf = this.pdfBlobUrls[value.idmensajes] || this.srcMediaMensaje(value)
						this.cargarPdfBlobRh(value).then((href) => {
							if (href) this.pdf = href
						})
						return
					}
          this.pdf = this.srcMediaMensaje(value)
        } else {
          this.pdf = value
        }
        this.dialogPDF = true
      },

      grabarAudio( ){
        
        // Activamos el navegador para poder iniciar una grabación
        navigator.mediaDevices.getUserMedia({ audio: true }).then(stream => {
	      	
	      	// Este cuadro de dialogo se abrirá solo pra mi
	      	if( [334, 3015, 1].includes( this.getdatosUsuarioERPERP.iderp )  ){
	      		
	      		this.dialogGrabacion = true

	      	}


	      	// Variables de grabación
	      	this.grabando = true
	      	this.audio    = true
          this.recording = true;

          // Crearmos el objeto de grabación
          this.recorder = RecordRTC(stream, {
            type: 'audio',
            mimeType: 'audio/mpeg',
            recorderType: RecordRTC.StereoAudioRecorder,
            desiredSampRate: 16000,
            numberOfAudioChannels: 1
          });

          // Iniciamos la grabación del audio
          this.recorder.startRecording();
					this._startDeferKpiNotifsWhileRecording()

        }).catch(error => {
        	
        	// No hay permisos, mostramos la alerta
          this.dialogMicrofono = true
        
        });
      },

      async sendAudio(){

      	/*
	      	this.recording = false;
		      this.recorder.stopRecording( async () => {
		        this.blob = this.recorder.getBlob();

		        // Una vez grabado el blob, es necesario enviarlo al servidor para que lo convierta a MP3
		        this.audioPath = await this.saveAudioConverter( this.blob ).then( response => response )

		        console.log( this.audioPath )

		        this.audio = true
		        this.file  = true

		        this.sendMessage()
		        
		      });
		    */

		    if( this.blob ){

		    	this.sendMessage()
		    
		    }else{

		    	this.recording = false;
		      this.recorder.stopRecording( async () => {
		        this.blob = this.recorder.getBlob();

		        // Una vez grabado el blob, es necesario enviarlo al servidor para que lo convierta a MP3
		        this.audioPath = await this.saveAudioConverter( this.blob ).then( response => response )

		        console.log( this.audioPath )

		        this.audio = true
		        this.file  = true

		        this.sendMessage()
		        
		      });

		    }
      },

      saveAudioConverter( ) {
      	return new Promise((resolve, reject ) => {

      		// Crear la ruta de axios
	      	const url = axios.defaults.baseURL + 'audio.parse'

	      	// Indicarle que es un dato blob y que enviara el archivo y lo convierta
		      axios.post(url, this.blob, { headers: { 'Content-Type': 'audio/mpeg' } } ).then(response => {
		      	
		      	// Si todo bien, retornamos la información
	          resolve( response.data )
	        }).catch(error => {

	        	// Si no, regresamos el error
	          reject( error )
	        });
      	})
	    },

	    deleteAudio(){
	    	this.recorder.reset()
			  this.recorder.clearRecordedData()
	      this.recorder.destroy()
	      this.cancelar()
	    },

	    pauseAudio( ){

	    	if( [334, 3015, 1].includes( this.getdatosUsuarioERPERP.iderp )  ){
	      		
		    	// Detener la grabación 
			    this.recording = false;
		      this.recorder.stopRecording( async () => {
			    	this.grabando = false
		        this.blob = this.recorder.getBlob();

		        // Una vez grabado el blob, es necesario enviarlo al servidor para que lo convierta a MP3
		        this.audioPath = await this.saveAudioConverter( this.blob ).then( response => response )

		        console.log( this.audioPath )

		        this.audio = true
		        this.file  = true

		        this._stopDeferKpiNotifsWhileRecording()

		      });

      	}else{
      		this.grabando = false
		    	this.recorder.pauseRecording()
      	}


	    },

	    playAudio(){


		    /*if( this.mediaRecorder ) {

		      this.mediaRecorder.resume();
		      this.grabando = true;
	        this.audioVisible = false;
		   
		    }*/

	    	if( [334, 3015, 1].includes( this.getdatosUsuarioERPERP.iderp )  ){
		    
				  const tempAudioURL = URL.createObjectURL(this.blob);

				  // Crear un nuevo audio y reproducirlo
				  const audio = new Audio(tempAudioURL);

				  audio.play();
				  
		    }else{
		    	this.mediaRecorder.resume();
		      this.grabando = true;
	        this.audioVisible = false;
		    }

	    },

	    scrolear( ){
				setTimeout(function(){document.getElementById('scroll-target').scrollTop = document.getElementById('scroll-target').scrollHeight},300);
	    },

	    reproducirDuranteGrabacion() {
			  this.recorder.getInternalRecorder().requestData();
			  const audioBlob = this.recorder.getBlob();
			  const tempAudioURL = URL.createObjectURL(audioBlob);

			  // Crear un nuevo audio y reproducirlo
			  const audio = new Audio(tempAudioURL);
			  audio.play();
			},

	    pegar(event) {
				event.stopPropagation()
				this.handlePaste(event)
      },

      abrirPegar(event) {
				this.handlePaste(event)
      },

			getClipboardImageFile(clipboardData) {
				const items = clipboardData.items ? Array.from(clipboardData.items) : []
				const imageItem = items.find(item => item.kind === 'file' && item.type.indexOf('image/') === 0)
				let file = imageItem ? imageItem.getAsFile() : null

				if (!file && clipboardData.files) {
					file = Array.from(clipboardData.files).find(item => item.type.indexOf('image/') === 0)
				}

				if (file && !file.name) {
					file = new File([file], 'imagen.png', { type: file.type || 'image/png' })
				}

				return file
			},

			isEditablePasteTarget(target) {
				if (!target) return false

				return ['INPUT', 'TEXTAREA'].includes(target.tagName) || target.isContentEditable
			},

      abrirModalUsuarios( item ){
      	console.log( item )
      	const { title } = item 

      	if( title == "Descargar" ){
      		console.log( this.mensajeReenviar )

      		if( this.mensajeReenviar.mio == 1 ){
      			window.open('https://escuelakpi.club/imagenes-whatsapp/' + this.mensajeReenviar.MediaUrl0 , '_blank');
      		}else{
      			this.mensajeReenviar.MediaUrl0
      			window.open('https://testfast.club/imagenes-whatsapp/' + this.mensajeReenviar.MediaUrl0 , '_blank');
      		}

      	}else{
      		this.dialogContactos.estatus = true
      	}
      },

      convertFile(dataurl, filename) {
        var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], filename, { type: mime });
      },

      verChat( value ){
      	console.log( value )
      	this.$emit('verChat', value )
      },


      async startRecording() {
	      try {
	        const audio = await Camera.getPhoto({
	          resultType: CameraResultType.Uri,
	          source: CameraSource.Microphone,
	        });
	        this.audioFile = audio.webPath; // Ruta del archivo de audio
	        console.log('Audio grabado:', this.audioFile);
	      } catch (error) {
	        console.error('Error al grabar audio:', error);
	      }
	    },
	    
	    playRecording() {
	      if (this.audioFile) {
	        const audio = new Audio(this.audioFile);
	        audio.play();
	      } else {
	        console.warn('No hay archivo de audio para reproducir.');
	      }
	    },

	    async stopRecording() {
	      try {
	        const result = await Media.stopRecording();
	        this.audioPath = result.path; // Ruta del archivo grabado
	        console.log('Grabación detenida:', result.path);
	      } catch (err) {
	        console.error('Error al detener la grabación:', err);
	      }
	    },

		closeSuggestedMessagesDialog(){
			this.suggestedMessagesDialog = false
		},
		showSnackbar(text){
			this.snackbar = true
			this.snackbarText = text
		}

		},
	}
</script>
<style  scoped>

	#sectionMessage{
		position: absolute;
	  top: 100%;
  	left: 0px;
  	width: 100%;
  	background-color: #e9edef;
  	padding: 10px;
	}

	.wa-footer-stack--wa {
		position: sticky;
		bottom: 0;
		left: 0;
		width: 100%;
		flex-shrink: 0;
		z-index: 5;
		background-color: #f0f2f5;
	}

	.wa-messages-mode #sectionMessage{
		position: relative;
		top: auto;
		bottom: auto;
		left: 0;
		width: 100%;
		flex-shrink: 0;
		z-index: 5;
		background-color: #f0f2f5;
		border-top: 1px solid #d1d7db;
	}

	.wa-messages-mode{
		display: flex;
		flex-direction: column;
		min-height: 100%;
	}

	.wa-messages-mode > .v-card__text{
		flex: 1 0 auto;
		padding: 18px 56px 84px !important;
		background: transparent !important;
	}

	.wa-messages-mode > .v-card__text > .row{
		margin: 0 !important;
		background: transparent !important;
	}

	.wa-messages-mode > .v-card__text > .row > .col{
		padding: 0 !important;
		background: transparent !important;
	}

	.wa-messages-mode > .v-card__text > .row > .col > span{
		display: block;
		width: 100%;
		clear: both;
	}

	.wa-messages-mode .message{
		display: flex !important;
		align-items: flex-start;
		margin-bottom: 8px !important;
		width: 100%;
		clear: both;
	}

	.wa-messages-mode .noresponse,
	.wa-messages-mode .response{
		display: flex;
		flex-direction: column;
		width: max-content;
		max-width: min(72%, 720px) !important;
		min-width: 0;
	}

	.wa-messages-mode .response{
		margin-left: auto !important;
		align-items: flex-end;
		float: none;
	}

	.wa-messages-mode .noresponse{
		margin-right: auto !important;
		align-items: flex-start;
		float: none;
	}

	.wa-messages-mode .text{
		display: block;
		width: max-content;
		min-width: 42px;
		max-width: 100%;
		margin: 0 !important;
		padding: 9px 12px !important;
		border-radius: 9px !important;
		box-shadow: 0 1px .5px rgba(11, 20, 26, .13);
		color: #111b21 !important;
		font-size: 14.5px;
		line-height: 1.45;
		overflow-wrap: break-word;
		word-break: normal;
		white-space: pre-wrap !important;
	}

	.wa-messages-mode .response .text{
		background: #d9fdd3 !important;
	}

	.wa-messages-mode .noresponse .text{
		background: #ffffff !important;
	}

	.wa-messages-mode .audio{
		width: 320px !important;
		max-width: 100% !important;
	}

	.wa-messages-mode .time{
		color: #667781 !important;
		font-size: 11px !important;
		margin: 2px 4px 0 !important;
		float: none !important;
		line-height: 1.3;
		max-width: 100%;
	}

	.wa-messages-mode .response-time{
		float: none !important;
		margin-right: 4px !important;
		text-align: right;
	}

	#sectionAsignacion{
		position: absolute;
	  top: 40px;
  	left: 80%;
  	width: 100%;
  	padding: 10px;
	}

	#preguntas::-webkit-scrollbar {
		-webkit-appearance: none !important;
	}

	.v-data-table--fixed-header > #preguntas::-webkit-scrollbar:vertical {
		width: 4px !important;
	}

	#preguntas::-webkit-scrollbar:vertical{
		width: 4px !important;
	}

	#preguntas::-webkit-scrollbar-button:increment,#preguntas::-webkit-scrollbar-button{
		display: none;
	}

	#preguntas::-webkit-scrollbar:horizontal{
		display: none;
	}

	#preguntas::-webkit-scrollbar-thumb{
		background-color: #BABCBF;
		border-radius: 20px;
		border: 1px solid #ededed;
	}

	/**********************************/

	#scroll-target::-webkit-scrollbar {
		-webkit-appearance: none !important;
	}

	#scroll-target::-webkit-scrollbar:vertical{
		width: 4px !important;
	}

	#scroll-target::-webkit-scrollbar-button:increment,#scroll-target::-webkit-scrollbar-button{
		display: none;
	}

	#scroll-target::-webkit-scrollbar:horizontal{
		display: none;
	}

	#scroll-target::-webkit-scrollbar-thumb{
		background-color: #BABCBF;
		border-radius: 20px;
		border: 1px solid #ededed;
	}




	#mensajesChat::-webkit-scrollbar {
		-webkit-appearance: none !important;
	}

	.v-data-table--fixed-header > #mensajesChat::-webkit-scrollbar:vertical {
		width: 4px !important;
	}

	#mensajesChat::-webkit-scrollbar:vertical{
		width: 4px !important;
	}

	#mensajesChat::-webkit-scrollbar-button:increment,#mensajesChat::-webkit-scrollbar-button{
		display: none;
	}

	#mensajesChat::-webkit-scrollbar:horizontal{
		display: none;
	}

	#mensajesChat::-webkit-scrollbar-thumb{
		background-color: #BABCBF;
		border-radius: 20px;
		border: 1px solid #ededed;
	}

	.container {
		padding:0;
		background-color: #FFF; 
		box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
		height: 750px;
		margin-top: 25px;
	}

	/* ===== MENU ===== */
	.menu {
		float: left;
		height: 700px;;
		width: 70px;
		background: #4768b5;
		background: -webkit-linear-gradient(#4768b5, #35488e);
		background: -o-linear-gradient(#4768b5, #35488e);
		background: -moz-linear-gradient(#4768b5, #35488e);
		background: linear-gradient(#4768b5, #35488e);
		box-shadow: 0 10px 20px rgba(0,0,0,0.19);
	}

	.menu .items {
		list-style:none;
		margin: auto;
		padding: 0;
	}

	.menu .items .item {
		height: 70px;
		border-bottom: 1px solid #6780cc;
		display:flex;
		justify-content: center;
		align-items: center;
		color: #9fb5ef;
		font-size: 17pt;
	}

	.menu .items .item-active {
		background-color:#5172c3;
		color: #FFF;
	}

	.menu .items .item:hover {
		cursor: pointer;
		background-color: #4f6ebd;
		color: #cfe5ff;
	}

	/* === CONVERSATIONS === */

	.discussions {
		width: 100%;
		height: 702px;
		box-shadow: 0px 8px 10px rgba(0,0,0,0.20);
		overflow: hidden;
		display: inline-block;
	}

	.discussions .discussion {
		width: 100%;
		height: 90px;
		background-color: #FAFAFA;
		display:flex;
		align-items: center;
		cursor: pointer;
	}

	.discussions .search {
		display:flex;
		align-items: center;
		justify-content: center;
		color: #E0E0E0;
	}

	.discussions .search .searchbar {
		height: 40px;
		background-color: #FFF;
		width: 70%;
		padding: 0 20px;
		border-radius: 50px;
		border: 1px solid #EEEEEE;
		display:flex;
		align-items: center;
		cursor: pointer;
	}

	.discussions .search .searchbar input {
		margin-left: 15px;
		height:38px;
		width:100%;
		border:none;
		font-family: 'Montserrat', sans-serif;;
	}

	.discussions .search .searchbar *::-webkit-input-placeholder {
		color: #E0E0E0;
	}
	.discussions .search .searchbar input *:-moz-placeholder {
		color: #E0E0E0;
	}
	.discussions .search .searchbar input *::-moz-placeholder {
		color: #E0E0E0;
	}
	.discussions .search .searchbar input *:-ms-input-placeholder {
		color: #E0E0E0;
	}

	.discussions .message-active {
		height: 90px;
		background-color: #FFF;
		border-right: solid 5px #E91E63;
	}

	.discussions .discussion .photo {
		margin-left:20px;
		display: block;
		width: 45px;
		height: 45px;
		background: #E6E7ED;
		-moz-border-radius: 50px;
		-webkit-border-radius: 50px;
		background-position: center;
		background-size: cover;
		background-repeat: no-repeat;
	}

	.online {
		position: relative;
		top: 30px;
		left: 35px;
		width: 13px;
		height: 13px;
		background-color: #8BC34A;
		border-radius: 13px;
		border: 3px solid #FAFAFA;
	}

	.desc-contact {
		height: 43px;
		width:50%;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.discussions .discussion .name {
		margin: 0 0 0 20px;
		font-family:'Montserrat', sans-serif;
		font-size: 11pt;
		color:#515151;
	}

	.discussions .discussion .message {
		margin: 6px 0 0 20px;
		font-family:'Montserrat', sans-serif;
		font-size: 9pt;
		color:#515151;
	}

	.timer {
		margin-left: 15%;
		font-family:'Open Sans', sans-serif;
		font-size: 11px;
		padding: 3px 8px;
		color: #BBB;
		background-color: #FFF;
		border: 1px solid #E5E5E5;
		border-radius: 15px;
	}

	.chat {
		width: calc(100%);
	}

	.chat .messages-chat {
		padding: 25px 10px;
	}

	.chat .messages-chat .message {
		display:flex;
		align-items: center;
		margin-bottom: 2px;
	}

	.chat .messages-chat .message .photo {
		display: block;
		width: 45px;
		height: 45px;
		background: #E6E7ED;
		-moz-border-radius: 50px;
		-webkit-border-radius: 50px;
		background-position: center;
		background-size: cover;
		background-repeat: no-repeat;
	}

	.chat .messages-chat .text {
		margin: 0 35px;
		background-color: #fff;
		padding: 15px;
		border-radius: 12px;
	}

	.text-only {
		white-space: pre-line;

	}

	.time {
		font-size: 12px;
		color:lightgrey;
		margin-bottom:10px;
		margin-left: 38px;
	}

	.response-time {
		float: right;
		margin-right: 40px !important;
	}

	.response {
		float: right;
		margin-right: 0px !important;
		margin-left: auto; /* flexbox alignment rule */
		max-width: 90%;
	}

	.noresponse {
		max-width: 90%;
	}

	.noresponse .text{
    box-shadow: 0 20px 27px 0 rgba(0,0,0,0.05)  !important;
	}

	.response .text {
		background-color: #c5e6c1 !important;
		color: black;
    box-shadow: 0 20px 27px 0 rgba(0,0,0,0.05)  !important;

	}

	.audio {
		background-color: #f1f3f4 !important;
	}

	.response .audio {
		background-color: #f1f3f4 !important;
	}

	.footer-chat {
		width: calc(65% - 66px);
		height: 80px;
		display:flex;
		align-items: center;
		position:absolute;
		bottom: 0;
		background-color: transparent;
		border-top: 2px solid #EEE;

	}

	.chat .footer-chat .icon {
		margin-left: 30px;
		color:#C0C0C0;
		font-size: 14pt;
	}

	.chat .footer-chat .send {
		color:#fff;
		background-color: #4f6ebd;
		position: absolute;
		right: 50px;
		padding: 12px 12px 12px 12px;
		border-radius: 50px;
		font-size: 14pt;
	}

	.chat .footer-chat .name {
		margin: 0 0 0 20px;
		text-transform: uppercase;
		font-family:'Montserrat', sans-serif;
		font-size: 13pt;
		color:#515151;
	}

	.chat .footer-chat .right {
		position: absolute;
		right: 40px;
	}

	.dropZone {
    width: 80%;
    height: 150px;
    position: relative;
    border: 2px dashed #eee;
  }

  .dropZone:hover {
    border: 2px solid #D8D8D8;
  }

  .dropZone:hover .dropZone-title {
    color: #1975A0;
  }

  .dropZone-info {
    color: #A8A8A8;
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translate(0, -50%);
    text-align: center;
  }

  .dropZone-title {
    color: #787878;
  }

  .dropZone input {
    position: absolute;
    cursor: pointer;
    top: 0px;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }

  .dropZone-upload-limit-info {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
  }

  .dropZone-over {
    background: #D8D8D8;
    opacity: 0.8;
  }

  .dropZone-uploaded {
    width: 80%;
    height: 200px;
    position: relative;
    border: 2px dashed #eee;
  }

  .dropZone-uploaded-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #D8D8D8;
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translate(0, -50%);
    text-align: center;
  }

  .removeFile {
    width: 200px;
  }


	.audio-recorder {
	  text-align: center;
	  position: relative;
	}

	canvas {
	  width: 80%;
	  height: 30px;
	  border-radius: 50px;
	  background: #f9f9f9;
	  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
	}


.audio-recorder {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 150px;
  background: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 10px;
}

.audio-canvas {
  width: 80%;
	height: 30px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
}

.recording-indicator {
  color: #ff4b5c;
  font-weight: bold;
  margin-top: 10px;
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}

.message-container {
  position: relative;
  display: inline-block;
  max-width: 100%;
}

.text {
  position: relative;
  margin-right: 30px; /* Espacio para el botón */
}

.forward-btn {
  position: absolute;
  right: -30px;
  top: 50%;
  transform: translateY(-50%);
  opacity: 0;
  transition: opacity 0.2s ease;
}

.message-container:hover .forward-btn {
  opacity: 1;
}

.twilio-imagen-lightbox__card {
  background: #111 !important;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.twilio-imagen-lightbox__close {
  z-index: 2;
  margin: 8px;
  background: rgba(0, 0, 0, 0.45) !important;
}

.twilio-imagen-lightbox__stage {
  flex: 1;
  min-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 16px 16px;
  cursor: zoom-out;
}

.twilio-imagen-lightbox__img {
  max-width: 100%;
  max-height: calc(100vh - 64px);
  width: auto;
  height: auto;
  object-fit: contain;
  display: block;
}

.twilio-pdf-preview {
  display: block;
  width: 240px;
  padding: 0;
  border: 0;
  border-radius: 10px;
  overflow: hidden;
  background: #f1f3f4;
  cursor: pointer;
  text-align: left;
}

.twilio-pdf-preview__frame {
  display: block;
  width: 240px;
  height: 180px;
  border: 0;
  pointer-events: none;
  background: #fff;
}

.twilio-pdf-preview__bar {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 8px;
}

.twilio-pdf-card__name {
  font-size: 13px;
  font-weight: 600;
  color: #111;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.twilio-pdf-card__hint {
  font-size: 12px;
  color: #5f6368;
}

</style>

